import Grid2 from '@mui/material/Unstable_Grid2';

import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { GlobalListTextCardContent } from '@/components/TopLevelComponents/GlobalList/GlobalList';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './TextList.styles';

interface TextListProps {
  list: GlobalListTextCardContent[];
  isOnDark?: boolean | undefined;
}

export default function TextList({ list, isOnDark }: TextListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });

  const TextListRow = ({
    heading,
    body,
  }: {
    heading?: string | undefined;
    body?: string | undefined;
  }) => {
    return (
      <GridContainer2 fixed gridProps={{ className: classes.textList }}>
        <Grid2 xs={6}>
          <h4 className={cx(globalClasses.h4, classes.textListHeading)}>
            {heading}
          </h4>
        </Grid2>
        <Grid2 xs={6}>
          <p className={cx(globalClasses.body, classes.textListBody)}>{body}</p>
        </Grid2>
      </GridContainer2>
    );
  };

  return (
    <>
      {list.map((textItem, index) => (
        <TextListRow key={`text-list-row-${index}`} {...textItem?.fields} />
      ))}
    </>
  );
}
